import { AddressState, EhrCoachGender, EhrCoachSpecialty } from 'types'

// One licensed-state entry in the onboarding form. `existingDocumentUrl` is the signed
// URL surfaced by the backend for a previously-uploaded image; when the coach picks a
// new file it goes into `file` and overrides the existing upload on submit.
export interface IStateLicenceFormRow {
  uid: number
  state: AddressState | ''
  expirationDate: Date | null
  expirationReminderEnabled: boolean
  file: File | null
  existingDocumentUrl: string | null
}

export interface ICoachProfileFormValues {
  firstName: string
  lastName: string
  gender: EhrCoachGender | ''
  stateOfResidence: string
  ethnicity: string
  additionalLanguages: string
  credentials: string
  cdrCnsNumber: string
  cdrCnsExpirationDate: Date | null
  specialties: EhrCoachSpecialty[]
  stateLicences: IStateLicenceFormRow[]
  bio: string
  // New file uploads (null until the coach picks one); held in form values and managed
  // via Controller so they validate and reset alongside the other fields.
  photo: File | null
  cdrCnsCard: File | null
}

// Form field keys that map 1:1 to a backend `missingFields` entry (snake_case).
export const MISSING_FIELD_TO_FORM_KEY: Record<string, keyof ICoachProfileFormValues> = {
  first_name: 'firstName',
  last_name: 'lastName',
  photo: 'photo',
  credentials: 'credentials',
  cdr_cns_number: 'cdrCnsNumber',
  cdr_cns_expiration_date: 'cdrCnsExpirationDate',
  specialties: 'specialties',
  gender: 'gender',
  state_of_residence: 'stateOfResidence',
  bio: 'bio',
  cdr_cns_card: 'cdrCnsCard',
  state_licences: 'stateLicences'
}
